import axios from 'axios';

const localUrl = 'http://192.168.0.205:8080/api';
//const localUrl = 'http://146.120.212.235:8080/api';
const mainUrl = '/api';

// В проде заголовок Authorization подставляет nginx (/api), в браузере логина нет.
// Для локальной разработки (прямой доступ к Gizmo) задай в .env.development.local:
// REACT_APP_GIZMO_USER=... и REACT_APP_GIZMO_PASS=...
const AUTH = process.env.REACT_APP_GIZMO_USER
    ? {
          username: process.env.REACT_APP_GIZMO_USER,
          password: process.env.REACT_APP_GIZMO_PASS,
      }
    : undefined;

function getBaseUrl() {
    const hostname = window.location.hostname;

    const isLocal =
        hostname === 'localhost' ||
        hostname === '127.0.0.1' ||
        /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);

    return isLocal ? localUrl : mainUrl;
}

export default async function getComputerList() {
    const base = getBaseUrl();
    const timeout = 4000;

    try {
        // --- 1. Группы ---
        let groupsRes = await axios.get(`${base}/hostgroups`, { auth: AUTH, timeout });
        let groups = groupsRes.data?.result || [];
        groups = groups.filter((g) => g.isDeleted !== true);

        // --- 2. Хосты ---
        let hostsRes = await axios.get(`${base}/hosts`, { auth: AUTH, timeout });
        let hosts = hostsRes.data?.result || [];
        hosts = hosts.filter((h) => h.isDeleted !== true);

        // --- 3. Активные сессии ---
        const sessionsRes = await axios.get(`${base}/usersessions/active`, {
            auth: AUTH,
            timeout,
        });
        const sessions = sessionsRes.data?.result || [];

        // --- 4. Балансы ---
        const balanceRes = await axios.get(`${base}/users/balance`, { auth: AUTH, timeout });
        const balances = balanceRes.data?.result || [];

        // MAP-lookup
        const sessionByHost = {};
        const balanceByUser = {};

        sessions.forEach((s) => {
            sessionByHost[s.hostId] = s;
        });

        balances.forEach((b) => {
            balanceByUser[b.userId] = {
                ...b,
                remainingMinutes: b.availableTime ?? 0,
            };
        });

        // --- создаём карту групп ---
        const groupsMap = {};
        groups.forEach((g) => {
            groupsMap[g.id] = { ...g, computers: [] };
        });

        // Группа "Без группы"
        groupsMap['none'] = {
            id: 'none',
            name: 'Без группы',
            computers: [],
        };

        // --- перекладываем компьютеры + добавляем сессию + баланс ---
        const computerList = hosts.map((h) => {
            const groupId = h.hostGroupId || 'none';

            const activeSession = sessionByHost[h.id] || null;

            let sessionWithBalance = null;

            if (activeSession) {
                const bal = balanceByUser[activeSession.userId] || null;

                sessionWithBalance = {
                    ...activeSession,
                    userBalance: bal,
                    remainingMinutes: bal?.remainingMinutes ?? 0, // <<< кладём сюда
                };
            }

            const data = {
                ...h,
                activeSession: sessionWithBalance,
            };

            return data;
        });

        const computerListSorted = computerList.sort((a, b) => a.number - b.number);

        return computerListSorted;
    } catch (err) {
        console.error('Ошибка Gizmo API:', err);
        return { error: true, message: err.message };
    }
}
